import { type SxProps, Typography } from "@mui/material";

type ErrorMessageProps = {
	message?: string;
	sx?: SxProps;
};

export const ErrorMessage = ({ message, sx }: ErrorMessageProps) => {
	if (!message) {
		return null;
	}

	return (
		<Typography
			data-focusableerror={true}
			variant="caption"
			color="error"
			sx={sx}
		>
			{message}
		</Typography>
	);
};

// This is a workaround to focus the first error field. Would be nice to get rid of the custom root.error handling and this timeout
export const focusErrorMessageComponent = () => {
	setTimeout(() => {
		const errorElement = document.querySelector(
			'[data-focusableerror="true"]',
		) as HTMLElement | null;
		if (errorElement) {
			errorElement.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
			errorElement.focus();
		}
		// Should be enough to let react update the DOM after the form.setError(`root.error`) call
	}, 100);
};
